function isSupportUrl(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  try {
    const { pathname } = new URL(value, 'https://portal.invalid');
    return (
      pathname === '/support-concierge' ||
      pathname.startsWith('/support-concierge/')
    );
  } catch {
    return false;
  }
}

// Replay masking does not cover analytics properties such as request text or
// attachment URLs. Suppress track/page calls while private support is displayed.
export function shouldSuppressSupportAnalytics(
  properties?: Record<string, unknown>,
): boolean {
  const urls = [
    typeof window === 'undefined' ? undefined : window.location.href,
    properties?.page,
    properties?.url,
    properties?.path,
    properties?.pathname,
  ];
  const privateSurfaceOpen =
    typeof document !== 'undefined' &&
    document.querySelector('[data-support-concierge-private]') !== null;
  return privateSurfaceOpen || urls.some(isSupportUrl);
}
